import { Component, ViewChild } from '@angular/core';
import { AgendaService } from '../agenda.service';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { HttpParams } from '@angular/common/http';
import { EventosGeneralesI } from 'src/app/interfaces/eventos.interface';
import { months } from 'src/app/interfaces/month.array';
import { UserI } from 'src/app/interfaces/user.interface';
import { DialogComponent } from '../../dialog/dialog.component';

export interface Eventos extends EventosGeneralesI {
  link?: string | null;
  id_reg?: number | null;
  hallazgo?: string | null;
  accion?: string | null;
}

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css'],
})
export class CalendarioComponent {
  constructor(
    private readonly service: AgendaService,
    private readonly auth: AuthLoginService
  ) {}

  dias = [6, 5, 4, 3, 2, 1];

  calendario: {
    fecha: Date;
    diaSemana: number;
    eventos?: Eventos[];
  }[] = [];

  horas: number[] = [];

  diasNombre: { dia: string; index: number }[] = [
    { dia: 'Domingo', index: 0 },
    { dia: 'Lunes', index: 1 },
    { dia: 'Martes', index: 2 },
    { dia: 'Miércoles', index: 3 },
    { dia: 'Jueves', index: 4 },
    { dia: 'Viernes', index: 5 },
    { dia: 'Sábado', index: 6 },
  ];

  user!: UserI;
  async ngOnInit() {
    //* Creamos la lista de horas
    for (let i = 0; i <= 24; i++) {
      this.horas.push(i);
    }
    await this.getCalendario();

    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    this.user = userState.user;
    await this.getCalendarioSemana();
  }

  async restoreDate() {
    this.mes = new Date().getMonth() + 1;
    this.anio = new Date().getFullYear();
    await this.getCalendario();
  }
  mes = new Date().getMonth() + 1;
  anio = new Date().getFullYear();
  month = months;

  getFecha() {
    const fecha = new Date(this.anio, this.mes - 1, 1);
    return { mes: fecha.getMonth(), anio: fecha.getFullYear() };
  }

  async changeDate(number: number) {
    this.mes += number;
    if (this.mes === 0) {
      this.mes = 12;
      --this.anio;
    } else if (this.mes === 13) {
      this.mes = 1;
      ++this.anio;
    }
    await this.getCalendario();
  }

  async getCalendario() {
    const mes = this.mes;
    const anio = this.anio;
    this.calendario = this.generarCalendario(mes, anio);
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    let params = new HttpParams();

    params = params.set('usuario', userState.user.id!);
    params = params.set('mes', mes);
    params = params.set('anio', anio);

    if (userState.user.lob?.some((l) => l.name === 'Proyectos'))
      params = params.set('lob', 'Proyectos');

    this.service
      .getAgendaByMonth(params)
      .subscribe((data) => (this.calendario = data));
  }

  generarCalendario(
    mes: number,
    año: number
  ): { fecha: Date; diaSemana: number }[] {
    const calendario: { fecha: Date; diaSemana: number }[] = [];
    const primerDia = new Date(año, mes - 1, 1);
    const ultimoDia = new Date(año, mes, 0);

    // Obtener el día de la semana del primer día del mes (0 para domingo, 1 para lunes, etc.)
    const primerDiaSemana = primerDia.getDay();

    // Llenar el arreglo con las fechas y sus respectivos días de la semana
    for (let dia = 1; dia <= ultimoDia.getDate(); dia++) {
      const fecha = new Date(año, mes - 1, dia);
      const diaSemana = (primerDiaSemana + dia - 1) % 7; // Ajustar para el día de la semana actual

      calendario.push({ fecha, diaSemana });
    }
    return calendario;
  }

  retornarFaltante(i: number) {
    const restante = this.calendario.slice(this.calendario.length - i);
    return restante;
  }

  returnDate(date: any): number {
    return new Date(date).getDate();
  }

  visible = false;
  evento: Eventos | null = null;
  eventoClick(ev: Eventos) {
    this.visible = true;
    this.evento = ev;
  }

  hide() {
    this.evento = null;
  }

  isVencida(date: any) {
    const d = new Date(date);
    const today = new Date();
    return d < today;
  }

  stateOptions: any[] = [
    { label: 'Mensual', value: 'men' },
    { label: 'Semanal', value: 'sem' },
    // { label: 'Diario', value: 'd' },
  ];

  value: string = 'men';

  //! Semanal -------------------------------------------------------------------------->
  async changeVisual() {}

  calendarioSemana: {
    fecha: Date;
    diaSemana: number;
    eventos?: Eventos[];
  }[] = [];

  hoy = new Date();
  finSemana = new Date();

  async changeDateSemana(d: number) {
    this.hoy.setDate(this.hoy.getDate() + d);
    await this.getCalendarioSemana();
  }

  async restoreDateSemana() {
    this.hoy = new Date();
    await this.getCalendarioSemana();
  }

  generarCalendarioSemanal(): {
    fecha: Date;
    diaSemana: number;
    eventos?: Eventos[];
  }[] {
    const calendario: {
      fecha: Date;
      diaSemana: number;
      eventos?: Eventos[];
    }[] = [];

    for (
      let d = new Date(this.hoy);
      d <= this.finSemana;
      d.setDate(d.getDate() + 1)
    ) {
      const fecha = new Date(d);
      const diaSemana = fecha.getDay();
      const date = new Date();
      date.setHours(19, 30, 0, 0);
      const dd = new Date();
      dd.setHours(20, 0, 0, 0);
      calendario.push({
        fecha,
        diaSemana,
        eventos: [
          {
            id: d.getDate(),
            titulo: '',
            descripcion: '',
            inicio: date,
            fin: dd,
            opcion_recordatorio: '',
            recordatorio: new Date(),
            color: '',
            id_usuario: this.user,
            id_lob: { id: '' },
          },
        ],
      });
    }

    return calendario;
  }

  retornarDia(j: number) {
    return this.diasNombre.find((i) => i.index === j)?.dia;
  }

  /** Calculamos el ancho del div, dependiendo de la hora establecida desde hasta */
  calcularHeight(ev: Eventos) {
    const fin = new Date(ev.fin);
    const inicio = new Date(ev.inicio);
    const dif = fin.getTime() - inicio.getTime();
    return Math.round(dif / 60000);
  }
  /** Calculamos la posición del div dependiendo de la hora  */
  calcularPosition(ev: Eventos) {
    const inicio = new Date(ev.inicio);
    const date = new Date(inicio);
    date.setHours(0, 0, 0, 0);
    const dif = inicio.getTime() - date.getTime();
    return Math.round(dif / 60000) + 60;
  }

  async getCalendarioSemana() {
    this.hoy.setHours(0, 0, 0, 0);
    this.finSemana = new Date(this.hoy);
    this.finSemana.setDate(this.hoy.getDate() + 6);
    this.finSemana.setHours(23, 59, 59, 999);

    this.calendarioSemana = this.generarCalendarioSemanal();

    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    let params = new HttpParams();

    params = params.set('usuario', userState.user.id);
    params = params.set('desde', this.hoy.toDateString());
    params = params.set('hasta', this.finSemana.toDateString());

    if (userState.user.lob?.some((l) => l.name === 'Proyectos'))
      params = params.set('lob', 'Proyectos');

    this.service.getAgendaByWeek(params).subscribe((data) => {
      this.calendarioSemana = data;
    });
  }

  @ViewChild('dialog') dialog!: DialogComponent;
  delete(id: number) {
    this.dialog.confirm(
      '¿Está seguro / a de eliminar este evento?',
      'Confirmación de carga',
      () => {
        this.onDelete(id);
      }
    );
  }

  onDelete(id: number) {
    this.dialog.start();
    this.service.deleteEvento(id).subscribe({
      next: (data) => {
        this.dialog.stop(
          'El evento se eliminó con éxito.',
          'Confirmación de carga',
          () => {
            this.calendario.forEach((c) => {
              c.eventos = c.eventos?.filter(
                (e) => e.titulo !== this.evento?.titulo
              );
            });
            this.visible = false;
          }
        );
      },
      error: (e) => {
        this.dialog.stop(
          'Ocurrió un error durante la solicitud.',
          'Error de carga',
          () => {},
          true
        );
      },
    });
  }
}
